var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-management"},[_c('SimpleTable',{ref:"leftTable",attrs:{"table-code":"menuManagement","menus":['插入', '插入下级', '查询', '批量修改', '批量删除'],"columns":_vm.columns,"data":_vm.tableData,"loading":_vm.loading},on:{"modify-data-change":_vm.onModifyDataChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }